import * as React from 'react';
import { Col, FormGroup, Input, Row } from 'reactstrap';
import { DateInput } from 'src/components/shared/Input/DateInput';
import { Svg } from 'src/components/shared/Svg';
import { ICreateStepDto } from 'src/model/dto/step-dto';

interface IPropositionStepItemEditionProps {
  edit: boolean;
  index: number;
  step: ICreateStepDto;
  handleStepChange: (step: ICreateStepDto, index: number) => void;
  deleteStep: (stepNumber: number) => void;
}

export const PropositionStepItemEdition: React.SFC<
  IPropositionStepItemEditionProps
> = ({ deleteStep, edit, handleStepChange, index, step }) => {
  const handleChange = (e: React.ChangeEvent<Element>) => {
    const newStep = {
      ...step,
      [(e.target as any).name]: (e.target as any).value,
    };
    handleStepChange(newStep, index);
  };

  const handleDateChange = (date: Date) => {
    const newStep = {
      ...step,
      startingDate: date,
    };
    handleStepChange(newStep, index);
  };

  const handleEstimatedDateChange = (date: Date) => {
    const newStep = {
      ...step,
      estimatedEndDate: date,
    };
    handleStepChange(newStep, index);
  };

  return (
    <Row className='mt-3'>
      <Col
        className='d-flex flex-column align-items-center position-relative'
        xs='2'
      >
        <span
          className='step-number text-center text-white mt-1'
          style={{ zIndex: 10 }}
        >
          {step.stepNumber}
        </span>
        <Svg
          className='position-absolute'
          width={48}
          height={48}
          fill='primary'
          src='step-bulle'
        />
        {edit && (
          <Svg
            width={12}
            height={12}
            fill='dark'
            src='close'
            onClick={() => deleteStep(step.stepNumber)}
            className='position-absolute'
            style={{
              cursor: 'pointer',
              right: '10px',
              top: '-5px',
              zIndex: 10,
            }}
          />
        )}
      </Col>
      <Col xs='10'>
        <Row className='w-100'>
          <Col xs='12'>
            <FormGroup>
              <Input
                type='text'
                name='title'
                placeholder={`Titre de l'étape`}
                disabled={!edit}
                value={step.title}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className='w-100'>
          <Col xs='6'>
            <FormGroup>
              <span className='d-block font-weight-bolder mb-2'>
                Date de début de l'étape
              </span>
              <DateInput
                edit={edit}
                name='startingDate'
                handleDateChange={handleDateChange}
                value={
                  step.startingDate ? new Date(step.startingDate) : new Date()
                }
                dateFormat='dd/MM/yyyy'
              />
            </FormGroup>
          </Col>
          <Col xs='6'>
            <FormGroup>
              <span className='d-block font-weight-bolder mb-2'>
                Date de fin de l'étape
              </span>
              <DateInput
                edit={edit}
                name='estimatedEndDate'
                handleDateChange={handleEstimatedDateChange}
                value={
                  step.estimatedEndDate
                    ? new Date(step.estimatedEndDate)
                    : new Date()
                }
                dateFormat='dd/MM/yyyy'
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className='w-100'>
          <Col xs='12'>
            <FormGroup>
              <span className='d-block font-weight-bolder mb-2'>
                Description de l'étape
              </span>
              <Input
                type='textarea'
                name='description'
                placeholder={`Description de l'étape`}
                disabled={!edit}
                value={step.description}
                onChange={handleChange}
                style={{ minHeight: '80px' }}
              />
            </FormGroup>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/components/Project/PropositionEdition/PropositionStepListEdition/PropositionStepItemEdition.tsx